export const CompensationDetailsState = {
  earnings: [],
  deductions: [],
  total: {
    amount: 0,
  },
};
